import { For, Stack } from '@chakra-ui/react';

import type { JobSearchVM } from '@/modules/job/view-models';

import { JobCard } from '../JobCard/JobCard';

export type JobListProps = {
	isLoading: boolean
	jobList:   JobSearchVM[]

	handleAddInterestedJob?:    (id: string) => void
	handleRemoveInterestedJob?: (id: string) => void
};

export const JobList = ({
	handleAddInterestedJob,
	handleRemoveInterestedJob,
	isLoading,
	jobList,
}: JobListProps) => {
	if (isLoading) {
		return <div>Loading...</div>;
	}

	if (jobList.length === 0) {
		return <div>No Job found.</div>;
	}

	return (
		<Stack gap={6}>
			<For each={jobList}>
				{job => (
					<JobCard
						job={job}
						key={job.id}
						onClickAddInterestedJob={() => handleAddInterestedJob?.(job.id)}
						onClickRemoveInterestedJob={() => handleRemoveInterestedJob?.(job.id)}
					/>
				)}
			</For>
		</Stack>
	);
};
